<template>
  <div
    id="dashboardPage"
    class="main-content">
    <div class="row">
      <div class="col-md-12 text-center">
        <p>All data is displayed only for the current month</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-3">
        <router-link to="/admin/catalogue/types" class="dashbox dashbox-line-progress" >
          <i class="icon-fa icon-fa-tags text-primary"/>
          <span class="desc">
            Categories
          </span>
          <span class="title text-primary">
            {{ dashboard.categories }}
          </span>
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-3">
        <router-link to="/admin/catalogue/products" class="dashbox dashbox-line-progress">
          <i class="icon-fa icon-fa-star text-success"/>
          <span class="desc">
            Products
          </span>
          <span class="title text-success">
            {{ dashboard.products }}
          </span>
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-3">
        <router-link to="/admin/prescriptions" class="dashbox dashbox-line-progress">
          <i class="icon-fa icon-fa-shopping-cart text-danger"/>
          <span class="desc">
            New Orders
          </span>
          <span class="title text-danger">
            {{ dashboard.new_orders }}
          </span>
        </router-link>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-3">
        <router-link to="/admin/prescriptions" class="dashbox dashbox-line-progress">
          <i class="icon-fa icon-fa-comments text-info"/>
          <span class="desc">
            New refills
          </span>
          <span class="title text-info">
            {{ dashboard.new_refills }}
          </span>
        </router-link>
      </div>
    </div>
    <div v-if="dashboard.graph.days.length !== 0" class="row">
      <div class="col-lg-12 mt-2">
        <div class="card">
          <div class="card-header">
            <h6><i class="icon-fa icon-fa-line-chart text-primary"/>Prescriptions</h6>
          </div>
          <div class="card-body">
            <line-graph :labels="dashboard.graph.days" :values="dashboard.graph.orders"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xl-6 mt-2">
        <div class="card">
          <div class="card-header">
            <h6><i class="icon-fa icon-fa-shopping-cart text-danger"/> Pending orders and refills</h6>
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Date</th>
                  <th>Cost</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(order, idx) in dashboard.pending_orders" :key="idx">
                  <td>{{ order.customer }}</td>
                  <td>{{ order.date }}</td>
                  <td>{{ order.total }} $</td>
                  <td><router-link :to="'/admin/prescriptions/' + order.id" class="btn btn-default btn-xs">View</router-link></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 mt-2">
        <div class="card">
          <div class="card-header">
            <h6><i class="icon-fa icon-fa-users text-info"/> New customers</h6>
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Clinic</th>
                  <th>Doctor</th>
                  <th>Reg. date</th>
                </tr>
              </thead>
              <tbody v-for="(customer, idx) in dashboard.new_customers" :key="idx">
                <tr>
                  <td>{{ customer.clinic }}</td>
                  <td>{{ customer.doctor }}</td>
                  <td>{{ customer.reg_date }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
/* global axios */
import LineGraph from '../../../components/chartjs/LineChart.vue'

export default {
  components: {
    LineGraph
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/admin/dashboard')
      .then(repsonse => {
        next(vm => (vm.dashboard = repsonse.data.dashboard))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  data () {
    return {
      header: 'header',
      dashboard: {
        graph: {
          days: [],
          orders: []
        }
      }
    }
  }
}
</script>
